import * as React from 'react';

interface State {
    cardImageClass: string;
}

export default class CardDiv extends React.Component<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {
            cardImageClass: window.Obiwan.enablePartpay ? 'card-div__cards__card__small-margin' : 'card-div__cards__card',
        };
    }

    public componentDidMount() {
        window.Obiwan.shippingModal('shipping-modal');
        window.Obiwan.returnsModal('returns-modal');
    }

    public render = () => {
        return (
            <div className="card-div">
                <div className="card-div__link-row">
                    <a className="text text--link text--center card-div__link-row__link" href="/faqs">Help</a>
                    <div id="shipping-modal" className="card-div__link-row__link">Shipping & Delivery</div>
                    <div id="returns-modal" className="card-div__link-row__link">Returns, Refunds & Cancellation Policy</div>
                </div>
                <div className="card-div__cards">
                    <div className="card-div__cards__checkout-div">
                        <img alt='' height={25} src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/SecurePadlockGrey.svg" />
                        <strong>SECURE CHECKOUT</strong>
                    </div>
                    <div className={this.state.cardImageClass}>
                        <img alt='visa' height={30} src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/visa.svg" />
                    </div>
                    <div className={this.state.cardImageClass}>
                        <img alt='mastercard' height={30} src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/mastercard.svg" />
                    </div>
                    {window.Obiwan.enablePartpay &&
                        <div className={this.state.cardImageClass}>
                            <img alt='zip' height={20} src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/ZipLogo.svg" />
                        </div>}
                </div>
                <div className="card-div__info">
                    <p>
                        Eve Wellness Co Ltd. uses SSL, does not store credit card details and all payments are handled by a secure PCI compliant third party.
                    </p>
                    <p>
                        <strong>Eve by BePure</strong><br />
                        407 Orchard Rd, Camberley, Hastings 4120<br />
                        0800 FOR EVE
                    </p>
                </div>
            </div>
        );
    }

}
